import type { JSX } from "react";

import { Select } from "@mantine/core";

import { useSalesContext } from "../../../../sales-context/SalesContext";
import { GrayWorld } from "./icons/GrayWorld";
import { abbreviations, useLanguageStore } from "./useLanguageStore";

export function LanguageSelector(): JSX.Element | null {
    const { taskType, taskData, disclosurePlayback } = useSalesContext();
    const { abbreviation, updateLanguage } = useLanguageStore();

    if (!taskType.isVoice && !taskType.isChat) {
        return null;
    }

    if (taskData.locale !== "es-mx") {
        return null;
    }

    return (
        <Select
            data-testid="language-selector"
            data={[...abbreviations]}
            value={abbreviation}
            onChange={updateLanguage}
            // Lock the language while a disclosure is playing: switching mid-play would desync the
            // completion timer / script / disclosure copy from the audio actually in flight.
            disabled={disclosurePlayback?.state === "playing"}
            allowDeselect={false}
            withCheckIcon={false}
            comboboxProps={{ withinPortal: false }}
            leftSection={<GrayWorld />}
            maw={90}
            fz="xs"
            size="xs"
            styles={{
                input: {
                    fontSize: 12,
                },
            }}
        />
    );
}
